import { render, staticRenderFns } from "./Engineering.vue?vue&type=template&id=4f8efc5a&scoped=true&"
import script from "./Engineering.vue?vue&type=script&lang=js&"
export * from "./Engineering.vue?vue&type=script&lang=js&"
import style0 from "./Engineering.vue?vue&type=style&index=0&id=4f8efc5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f8efc5a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
